/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import { Clickable } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-skills';

const styles = {
  SelectionControl: (theme: Theme) =>
    css({
      background: 'var(--cds-color-neutral-background-primary)',
      border: `1px solid var(--cds-color-neutral-primary)`,
      borderRadius: '100px',
      padding: '6px 15px',
      color: 'var(--cds-color-neutral-primary)',
      minWidth: '134px',
    }),
  SelectionControlSelected: (theme: Theme) => ({
    borderRadius: '100px',
    padding: '6px 15px',
    minWidth: '134px',
    background: 'var(--cds-color-blue-800)',
    border: `1px solid var(--cds-color-blue-700)`,
    color: 'var(--cds-color-neutral-primary-invert)',
  }),
  common: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
};

const SelectionControl: React.FC<{ selected: boolean } & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  selected,
  ...props
}) => {
  return (
    <Clickable {...props}>
      <div css={[selected ? styles.SelectionControlSelected : styles.SelectionControl, styles.common]}>
        <Typography2 component="p" color={selected ? 'invertBody' : 'body'}>
          {selected ? _t('Selected') : _t('Unselected')}{' '}
        </Typography2>
        {selected ? (
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.5" cy="7" r="7" fill="white" />
            <path
              d="M3.70826 6.70849L7.20826 9.91682L11.4999 4.50015"
              stroke="var(--cds-color-blue-800)"
              strokeWidth="0.75"
            />
          </svg>
        ) : (
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="7.5"
              cy="7.5"
              r="6.625"
              fill="white"
              stroke="var(--cds-color-neutral-primary)"
              strokeWidth="0.75"
            />
          </svg>
        )}
      </div>
    </Clickable>
  );
};

export default SelectionControl;
